module.exports = __webpack_public_path__ + "static/media/coin_hlc.76b45f94.png";